import { toast, throttle } from '@/utils';

// 实现浏览器复制功能
const copy = throttle((text, callback = () => toast.success('已复制内容到剪切板')) => {
  const textarea = document.createElement('textarea');
  // 防止IOS下自动唤起键盘
  textarea.readOnly = 'readonly';
  // 将textarea移出可视区域
  textarea.style.position = 'absolute';
  textarea.style.left = '-9999px'
  // 将text赋值给textarea.value属性，支持换行，数组逗号分隔
  textarea.value = text;
  // 插入到body中
  document.body.appendChild(textarea);
  // 选中值并复制
  textarea.select();
  textarea.setSelectionRange(0, textarea.value.length);
  document.execCommand('copy');
  // 删除元素
  document.body.removeChild(textarea);
  // 回调函数
  callback();
}, 1000);

export default copy;